import { noop } from "nodash"
import { createContext, FC } from "react"
import { LeftModalOptions } from "../MapProvider"

export const MapPortalContext = createContext<{
    register: (key: string, element: FC, options?: LeftModalOptions) => void
    unregister: (key: string) => void
    items: { key: string; element: FC; options: LeftModalOptions }[]
}>({ register: noop, unregister: noop, items: [] })
